module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_40.d8d1ce15.png";